var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1215_25838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2642 0.5H10.2592C4.74547 0.5 0.261719 5.20925 0.261719 11C0.261719 13.2969 0.966719 15.4257 2.16547 17.1543L0.919219 21.0551L4.76297 19.7649C6.34422 20.8647 8.23047 21.5 10.2642 21.5C15.778 21.5 20.2617 16.7894 20.2617 11C20.2617 5.21056 15.778 0.5 10.2642 0.5Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0834 15.3276C15.8421 16.0429 14.8846 16.6362 14.1209 16.8094C13.5984 16.9262 12.9159 17.0194 10.6184 16.0193C7.67965 14.7409 5.78715 11.6054 5.63965 11.4019C5.4984 11.1985 4.45215 9.74161 4.45215 8.23486C4.45215 6.72811 5.1809 5.99442 5.47465 5.67942C5.7159 5.42086 6.11465 5.30273 6.49715 5.30273C6.6209 5.30273 6.73215 5.3093 6.83215 5.31455C7.1259 5.32767 7.2734 5.34605 7.46715 5.83298C7.7084 6.4433 8.2959 7.95005 8.3659 8.10492C8.43715 8.2598 8.5084 8.4698 8.4084 8.67323C8.31465 8.88323 8.23215 8.97642 8.08465 9.15492C7.93715 9.33342 7.79715 9.46992 7.64965 9.66155C7.51465 9.82823 7.36215 10.0067 7.53215 10.3152C7.70215 10.617 8.28965 11.6237 9.15465 12.4322C10.2709 13.4757 11.1759 13.809 11.4996 13.9508C11.7409 14.0558 12.0284 14.0309 12.2046 13.834C12.4284 13.5807 12.7046 13.1607 12.9859 12.7472C13.1859 12.4506 13.4384 12.4139 13.7034 12.5189C13.9734 12.6173 15.4021 13.3589 15.6959 13.5124C15.9896 13.6673 16.1834 13.7408 16.2546 13.8707C16.3246 14.0007 16.3246 14.611 16.0834 15.3276Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1215_25838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 21,
    fill: "white",
    transform: "translate(0.261719 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.ed4f0b4d71c8f18567a9326a70a65aa3.svg";
export { ForwardRef as ReactComponent };